import React, { useEffect, useRef, useState } from "react";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useNavigate } from "react-router";
import style from "./Login.module.css";
import logo from "../../assets/logo.png";
import loginillustration from "../../assets/loginillustration.png";
import { collection, getDocs, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
// import style from "./Adduser.module.css";
import { TbUserEdit } from "react-icons/tb";
import { BsEye, BsPersonAdd } from "react-icons/bs";
import { RiLockPasswordLine } from "react-icons/ri";
import { BiSolidImageAdd } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { auth, storage, db } from "../../firebase/config";
import { v4 as uuid } from "uuid";
const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [displayname, setDisplayname] = useState("client");
  const [rule, setRule] = useState("client");
  const [error, setError] = useState(false);
  const [userarray, setUserarray] = useState([]);
  const navigate = useNavigate();
  const [photo, setPhoto] = useState(
    "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/client.jpg?alt=media&token=2de615ef-95b2-4e61-933d-3572ba0f4fa5"
  );
  const pass = useRef();
  useEffect(() => {
    const fetchCallCenterUsers = async () => {
      try {
        const callCenterUsersSnapshot = await getDocs(
          query(collection(db, "users"), where("callCenter", "==", true))
        );
        const admin = await getDocs(
          query(collection(db, "users"), where("rule", "==", "admin"))
        );
        const updatedAdminArray = admin.docs.map(doc => {
          const data = doc.data();
          console.log('Fetched user:', data); // Log the fetched user data
          return {
            un_read_message: 0,
            user_id: doc.id, // Ensure this is unique and correct
          };
        });
        const updatedArray = callCenterUsersSnapshot.docs.map(doc => {
          const data = doc.data();
          console.log('Fetched user:', data); // Log the fetched user data
          return {
            un_read_message: 0,
            user_id: doc.id, // Ensure this is unique and correct
          };
        });

        // Log the updatedArray to check for duplicates
        console.log('Updated array:', updatedArray);

        setUserarray(prevArray => {
          // Combine the previous array with the updated array
          const combinedArray = [...prevArray, ...updatedArray,...updatedAdminArray];
          
          // Remove duplicates
          const uniqueArray = combinedArray.filter((item, index, self) =>
            index === self.findIndex(t => t.user_id === item.user_id)
          );

          return uniqueArray;
        });
      } catch (error) {
        console.error("Error fetching call center users: ", error);
      }
    };

    fetchCallCenterUsers();
  }, []);
  const addUserToUserArray = (uid, photoURL) => {
    const newUser = {
      un_read_message: 0,
      user_id: uid,
    };
  
    setUserarray((prevArray) => [...prevArray, newUser]);
  };
  const adduser = async (e) => {
    e.preventDefault();
    const file = e.target[4].files[0];
    // let newUser = null;
  
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);
  
      if (file !== undefined) {
        const storageRef = ref(storage, uuid());
        const uploadTask = uploadBytesResumable(storageRef, file);
  
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case "paused":
              case "running":
                break;
            }
          },
          (error) => {
            console.error("Upload error: ", error);
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            await updateProfile(res.user, {
              displayName: displayname,
              photoURL: downloadURL,
            });
            await setDoc(doc(db, "users", res.user.uid), {
              displayname,
              email,
              photoURL: downloadURL,
              uid: res.user.uid,
              rule: rule,
              callCenter: false
            });
            const  newUser = [...userarray,{
              un_read_message: 0,
              user_id: res.user.uid,
            }];
            const uid = uuid();
            await setDoc(doc(db, "messages", uid), { message: [] });
            await setDoc(doc(db, "roomuser", uid), {
              createdat: serverTimestamp(),
              users: [],
              imageurl: downloadURL,
              name: displayname,
              uid: uid,
              enddate: null,
            });
            updateDoc(doc(db, "roomuser", uid), {
              users: newUser,
            });
          }
        );
      } else {
        await updateProfile(res.user, {
          displayName: displayname,
          photoURL: photo,
        });
        await setDoc(doc(db, "users", res.user.uid), {
          displayname,
          email,
          photoURL: photo,
          uid: res.user.uid,
          rule: rule,
          callCenter: false
        });
  
        const  newUser = [...userarray,{
          un_read_message: 0,
          user_id: res.user.uid,
        }];
        const uid = uuid();
        await setDoc(doc(db, "messages", uid), { message: [] });
        await setDoc(doc(db, "roomuser", uid), {
          createdat: serverTimestamp(),
          users: [],
          imageurl: photo,
          name: displayname,
          uid: uid,
          enddate: null,
        });
        updateDoc(doc(db, "roomuser", uid), {
          users: newUser,
        });
      }
  
      setConfirmPassword("");
      setEmail("");
      setDisplayname("");
      setPassword("");
      navigate("/");
    } catch (error) {
      alert(error);
    }
  };
  
  const updateRoomUser = async (newUser,displayName,photo) => {
    const uid = uuid();
    await setDoc(doc(db, "messages", uid), { message: [] });
    await setDoc(doc(db, "roomuser", uid), {
      createdat: serverTimestamp(),
      users: [],
      imageurl: photo,
      name: displayName,
      uid: uid,
      enddate: null,
    });
  
    // Fetch the updated user array including the new user
    // setUserarray((prevArray) => {
    //   const updatedUserarray = [...prevArray, newUser];
    //   // Clear the user array after updating
    //   setUserarray([]);
  
    //   return updatedUserarray;
    // });
    updateDoc(doc(db, "roomuser", uid), {
      users: userarray,
    });
  };
  const sowpassword = () => {
    if (pass.current.type === "password") {
      pass.current.type = "text";
    } else {
      pass.current.type = "password";
    }
  };
  return (
    <div className={style.container}>
      <div className={style.rcircle}></div>
      <div className={style.nav}>
        <a href="https://archminaashraf.com/">
          <img src={logo} />
        </a>
        <div className={style.text}>
          <h2>مرحبا بك في خدمة شاتنا</h2>
          <p>
            من فضلك يرجي تسجيل الدخول حتي تتمكن من التحدث مع المهندسين الموسؤلة
            عن مشروعك
          </p>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none">
          <path
            d="M8.3335 20.5L31.6668 20.5M8.3335 20.5L18.3335 10.5M8.3335 20.5L18.3335 30.5"
            stroke="#999999"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div className={style.loginbody}>
        <form onSubmit={adduser}>
          <div className={style.input}>
            <TbUserEdit size={25} color="#999" />
            <input
              type="text"
              value={displayname}
              onChange={(e) => setDisplayname(e.target.value)}
              placeholder="اسم الشخص"
            />
          </div>
          <div className={style.input}>
            <CgProfile size={25} color="#999" />
            <input
              type="text"
              placeholder="الايميل"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={style.input}>
            <RiLockPasswordLine size={25} color="#999" />
            <input
              ref={pass}
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="كلمة المرور"
            />
            <BsEye
              size={25}
              color="#999"
              cursor="pointer"
              onClick={sowpassword}
            />
          </div>
          <div className={style.input}>
            <RiLockPasswordLine size={25} color="#999" />
            <input
              type="password"
              required
              value={confirmpassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="تاكيد كلمة المرور "
            />
          </div>
          <input type="file" style={{ display: "none" }} id="file" />
          <label className={style.avatar} htmlFor="file">
            <BiSolidImageAdd size={40} />
            <span>add avatar</span>
          </label>
          {error ? (
            <span style={{ color: "red" }}>The Email or Password is wrong</span>
          ) : (
            ""
          )}
          <button type="submit">انشاء حساب</button>
        </form>
        <div className={style.illustration}>
          <img src={loginillustration} width="100%" height="100%" />
        </div>
      </div>
      <div className={style.lcircle}></div>
    </div>
  );
};
export default Signup;
